import { useEffect, useState } from "react";
import { buscarPessoasGerenciarService } from "../../../services/buscarPessoasGerenciarService";
import { formatPhoneNumber } from "../../../uteis/formatPhoneNumber";

type EtiquetaDTO = { id: number; nome: string; cor?: string | null };

type PessoaGerenciarDTO = {
  key: string;
  pessoaId: number;
  origem: "LEAD" | "USUARIO";
  leadId: number | null;
  usuarioId: number | null;
  nome: string | null;
  celular: string | null;
  status: string | null;
  tipo: string | null;
  observacoes: string | null;
  etiquetas: EtiquetaDTO[];
};

export const useBuscarPessoas = () => {
  const [pessoas, setPessoas] = useState<PessoaGerenciarDTO[]>([]);
  const [isLoading, setIsLoading] = useState(true);

  const fetchPessoas = async () => {
    setIsLoading(true);

    const data = await buscarPessoasGerenciarService();

  const safeData = Array.isArray(data) ? data : [];

    const arr: PessoaGerenciarDTO[] =safeData.map((p: any) => ({
      key: p.key, // "PESSOA-123"
      pessoaId: p.pessoaId,
      origem: p.origem,
      leadId: p.leadId ?? null,
      usuarioId: p.usuarioId ?? null,

      nome: p.nome ?? "",
      celular: formatPhoneNumber(p.celular ?? ""),

      status: p.status ?? null,
      tipo: p.tipo ?? null,
      observacoes: p.observacoes ?? null,

      etiquetas: (p.etiquetas ?? []).map((e: any) => ({
        id: e.id,
        nome: e.nome,
        cor: e.cor ?? null,
      })),
    }));

    setPessoas(arr);
    setIsLoading(false);
  };

  useEffect(() => {
    fetchPessoas();
  }, []);

  return { pessoas, isLoading, fetchPessoas, setPessoas };
};
